<template>
    <div>
        <Chart :cdata="cdata" />
    </div>
</template>

<script>
import Chart from './chart.vue'
import * as api from '@/api/index'
export default {
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            cdata: {
                xAxis: [],
                seriesData: []
            },
            month:[],   // 鏈€杩?2涓湀鏁扮粍
        };
    },
    components: {
        Chart,
    },
    watch: {
        data: {
            async handler(newv, oldv) {
                // 杩囨护鎺塵onth涓簄ull鐨勬暟鎹」
                let filteredData = newv.filter(item => item.month !== null && item.month !== undefined)
                console.log(filteredData, this.month, '娲楁钉瓒嬪娍7777777handler---------------')
                let category = await api.getCategoryPage()
                let typeArr = category.data.map(item=>{
                    return {
                        categoryName:item.name,
                        num:0
                    }
                })
                let newData = JSON.parse(JSON.stringify(filteredData))
                this.month = this.getMonth()
                let indexArr = []   // [10,11]
                this.month.map((item,index)=>{
                    let arr = item.split('-')
                    filteredData = newData.map((item2,index2)=>{
                        if(item2.month == arr[1]){
                            indexArr.push(index)
                            item2.index = index
                        }
                        return item2
                    })
                })
                // console.error('indexArr-------->',indexArr, this.month)
                this.month.map((item,index)=>{
                   if(indexArr.indexOf(index) == -1){
                    newData[index] = {
                        month:item,
                        num:0,
                        total:0,
                        type:typeArr
                    }
                   }else{
                    let arr = filteredData.find(item2 => item2.index == index )
                    if (arr) {
                        let typeData = (arr.type || []).map(item => {
                            return {
                                categoryName: item.categoryName,
                                num: item.num,
                            }
                        });
                        let resultArr = (typeArr || []).concat(typeData);
                        arr.type = this.removeSame(resultArr, 'categoryName');
                        arr.month = item;
                        newData[index] = arr;
                    }
                   }
                })
                if (newData) {
                    const arr = []
                    this.cdata.xAxis = []
                    this.cdata.seriesData = newData.map(v => {
                        if (v.type.length > 0) {
                            v.total = v.type.reduce((pre, ctx) => pre + ctx.num, 0)
                        } else {
                            v.total = 0
                        }
                        this.cdata.xAxis.push(v.month)
                        return {
                            value: v.num,
                            month: v.month,
                            type: v.type,
                            total: v.total
                        }
                    })
                }
            },
            deep: true,
            immediate: true,
        }
    },
    
    mounted() {
        
    },
    methods: {
        getMonth() {
            var dataArr = [];
            var data = new Date();
            var year = data.getFullYear();
            data.setMonth(data.getMonth() + 1, 1); //鑾峰彇鍒板綋鍓嶆湀浠?璁剧疆鏈堜唤
            for (var i = 0; i < 12; i++) {
                data.setMonth(data.getMonth() - 1); //姣忔寰幆涓€娆?鏈堜唤鍊煎噺1
                var m = data.getMonth() + 1;
                m = m < 10 ? "0" + m : m;
                dataArr.push(data.getFullYear() + "-" + m);
            }
            return dataArr.reverse();
        },
        removeSame(arr,u_key) {   // 鏁扮粍鏍规嵁鏌愪釜key鍘婚噸
            const obj = {}
            const result = []
            arr.forEach(item => {
                const typeof_key = typeof item[u_key] + item[u_key]
                obj[typeof_key] = item
            })
            for (const key in obj) {
                result.push(obj[key])
            }
            return result
        }
    }
};
</script>

<style lang="scss" scoped></style>
